import { BadgeDollarSign, Clock3, ScanLine, Users2, Briefcase, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { WaIcon } from "./Logo";
import { waOpen } from "../lib/site";
import { useContent } from "../lib/content";

const ICONS = [BadgeDollarSign, Clock3, ScanLine, Users2];

export default function Corporativo() {
    const t = useContent().corporativo;
    const msg = "Olá! Sou gestor(a) de uma empresa e quero receber a proposta de implantação do minimercado autônomo Conbox no nosso escritório. Podemos conversar?";

    return (
        <section
            id="corporativo"
            data-testid="corporativo-section"
            className="scroll-mt-24 bg-gradient-to-b from-[#0E6B3F] to-[#073A22] text-[#F7F4EC] py-20 sm:py-28 relative overflow-hidden"
        >
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -top-4 right-0 select-none text-[15vw] font-black lowercase leading-none tracking-tighter text-outline whitespace-nowrap"
            >
                empresa
            </div>

            <div className="mx-auto max-w-7xl px-4 sm:px-6 relative">
                <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-12 lg:gap-16 items-start">
                    <div>
                        <Reveal>
                            <SectionTag tone="yellow">{t.tag}</SectionTag>
                            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
                                {t.title1}
                                <span className="font-caveat text-[#F1C75B] font-bold text-4xl sm:text-5xl inline-block -rotate-1">
                                    {t.title2}
                                </span>
                            </h2>
                            <p className="mt-5 text-base sm:text-lg text-[#F7F4EC]/80 leading-relaxed max-w-xl">
                                {t.subtitle}
                            </p>
                        </Reveal>

                        <ul className="mt-9 grid sm:grid-cols-2 gap-4">
                            {t.pitches.map((p, i) => {
                                const Icon = ICONS[i] || BadgeDollarSign;
                                return (
                                    <Reveal key={i} delay={i * 0.08}>
                                        <li className="h-full rounded-2xl border-2 border-[#F7F4EC]/15 bg-[#F7F4EC]/5 p-6 hover:bg-[#F7F4EC]/10 hover:-translate-y-1 transition-all duration-300">
                                            <Icon className="w-8 h-8 text-[#F1C75B]" strokeWidth={2} />
                                            <h3 className="mt-4 text-lg font-extrabold">{p.t}</h3>
                                            <p className="mt-2 text-sm text-[#F7F4EC]/75 leading-relaxed">{p.d}</p>
                                        </li>
                                    </Reveal>
                                );
                            })}
                        </ul>
                    </div>

                    <Reveal delay={0.1}>
                        <div className="rounded-[2rem] bg-[#F7F4EC] text-[#1A231E] p-7 sm:p-9 sticker rotate-1">
                            <div className="flex items-center gap-3">
                                <Briefcase className="w-8 h-8 text-[#0E6B3F]" />
                                <h3 className="text-2xl font-extrabold">Sua empresa ganha um mercado</h3>
                            </div>
                            <ul className="mt-6 space-y-3.5 text-base font-semibold text-[#1A231E]/80">
                                <li className="flex items-center gap-3">
                                    <span className="w-2 h-2 rounded-full bg-[#F57A3A]" />
                                    Proposta apresentada ao RH e facilities
                                </li>
                                <li className="flex items-center gap-3">
                                    <span className="w-2 h-2 rounded-full bg-[#F57A3A]" />
                                    Projeto sob medida para o espaço corporativo
                                </li>
                                <li className="flex items-center gap-3">
                                    <span className="w-2 h-2 rounded-full bg-[#F57A3A]" />
                                    Operação e reposição 100% por conta da Conbox
                                </li>
                            </ul>
                            <button
                                data-testid="corporativo-cta-whatsapp"
                                onClick={() => waOpen(msg)}
                                className="mt-7 w-full inline-flex items-center justify-center gap-2.5 rounded-full bg-[#25D366] hover:bg-[#1FB457] text-[#073A22] font-extrabold px-6 py-4 text-base transition-all duration-200 hover:-translate-y-0.5"
                            >
                                <WaIcon className="w-5 h-5" />
                                {t.cta}
                                <ArrowRight className="w-5 h-5" />
                            </button>
                            <p className="mt-3 text-center text-xs text-[#1A231E]/50 font-semibold">
                                {t.cta_note}
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
